import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './DownloadRow.css'

export interface DownloadRowProps {
  title: ReactNode
  /** Fecha e importe, p. ej. "14 sep · 270,00 €" */
  meta?: ReactNode
  /** Sin href el enlace no se muestra (recibo aún no disponible) */
  href?: string | null
  /** Nombre accesible del enlace; por defecto "Descargar {title}" si title es texto */
  downloadLabel?: string
  className?: string
}

/** Fila de recibo o factura (bundle B3 §3h): 64 px, título, meta tabular y "Descargar" de 44 px en primary-soft. */
export function DownloadRow({ title, meta, href, downloadLabel, className }: DownloadRowProps) {
  const { t } = useTranslation()
  const label = downloadLabel ?? (typeof title === 'string' ? t('v2.ds.download.descargarNombre', { name: title }) : t('v2.ds.download.descargar'))
  return (
    <div className={cx('hp-download', className)}>
      <div className="hp-download__text">
        <div className="hp-download__title">{title}</div>
        {meta && <div className="hp-download__meta tnum">{meta}</div>}
      </div>
      {href && (
        <a className="hp-download__link" href={href} target="_blank" rel="noreferrer" download aria-label={label}>
          <Icon name="download" size={18} />
          <span aria-hidden="true">{t('v2.ds.download.descargar')}</span>
        </a>
      )}
    </div>
  )
}
